<template>
 <div style="height: 80vh" class="d-flex justify-center align-center">
    <v-progress-circular
      :size="50"
      color="blue"
      indeterminate
    ></v-progress-circular>
  </div>
</template>
<script>

import baseapifactory from "../../../apis/apifactory";
export default {
  setup() {},
  data() {
    return {
      counternumber: 100,
      countDown: 0,
    };
  },
  methods: {

   
     call_api_checkdata() {
      //alert("call_api_checkdata_fordataprepration");
      baseapifactory
        .api_get_project_data_instep1()
        .then((res) => {
          //alert(JSON.stringify(res));
          
          if (res.data.status != 402) {
            this.$router.push("/edaanalysis");
          }
          else{
             alert("Sorry Please set the project .");
              this.$router.push("/settingproject");

          }
        })
        .catch(function (error) {
          alert("call_api_save_step3" + error);
          // return false;
        });
    },
  

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    countDownTimerIncrease() {
      setTimeout(() => {
        this.countDown += 1;
        this.countDownTimerIncrease();
      }, 1000);
    },
  },
  computed: {
    getcounter() {
      return this.counternumber + 1;
    },
  },
  created() {
    this.countDownTimerIncrease();
  },

  mounted() {
    
    //this.callworkflowsteps();
    this.call_api_checkdata();
    
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
